import {
  createPasswordlessCode,
  consumePasswordlessCode,
  getPasswordlessLoginAttemptInfo,
} from 'supertokens-web-js/recipe/thirdpartypasswordless';
import { getLocaleFromPath } from '@/utils/getLocaleFromPath';
import { getServerTranslator } from '@/utils/serverI18n';



/** Session storage key for the URL to redirect to after login (magic link or OAuth). */
export const LOGIN_RETURN_URL_KEY = 'lm_login_return_url';

/**
 * Returns a safe redirect path from sessionStorage (must start with / and not be protocol-relative).
 * @returns {string|null} Path to redirect to, or null if none or invalid.
 */
export function getLoginReturnUrl() {
  if (typeof window === 'undefined') return null;
  const url = window.sessionStorage.getItem(LOGIN_RETURN_URL_KEY);
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();
  if (trimmed.startsWith('/') && !trimmed.startsWith('//') && trimmed.length < 2048) return trimmed;
  return null;
}

/**
 * Stores the return URL in sessionStorage so post-login redirect can use it.
 * Call this when navigating to signin/signup (e.g. from signin page on load).
 * @param {string} path - Path to store (e.g. from query or pathname).
 */
export function setLoginReturnUrl(path) {
  if (typeof window === 'undefined' || !path || typeof path !== 'string') return;
  const trimmed = path.trim();
  if (trimmed.startsWith('/') && !trimmed.startsWith('//') && trimmed.length < 2048) {
    window.sessionStorage.setItem(LOGIN_RETURN_URL_KEY, trimmed);
  }
}


export async function isThisSameBrowserAndDevice() {
  return (await getPasswordlessLoginAttemptInfo()) !== undefined;
}

export async function hasInitialMagicLinkBeenSent() {
  return await getPasswordlessLoginAttemptInfo() !== undefined;
}

export async function sendMagicLink(email) {
  const { t } = getServerTranslator(getLocaleFromPath(window.location.pathname));
  try {

      let response = await createPasswordlessCode({ email });
      // Magic link sent successfully
      console.log('response: ', response);
      window.alert(t('auth.magicLinkSent'));

  } catch (err) {
    if (err.isSuperTokensGeneralError === true) {
      // Custom error message from the API
      window.alert(err.message);
    } else {
      console.log('Error in magic link login attempt: ', err);
      window.alert(t('auth.genericError'));
    }
  }
}

export async function handleMagicLinkClicked() {
  const { t } = getServerTranslator(getLocaleFromPath(window.location.pathname));
  try {
    // Ensure session storage has the required state
    const authState = await getPasswordlessLoginAttemptInfo();
    if (!authState) {
      throw new Error(t('auth.noAuthState'));
    }

    let response = await consumePasswordlessCode();

    if (response.status === 'OK') {
      if (response.createdNewUser) {
        // User sign up success
        console.log('New user added...', response);
      } else {
        // User sign in success
        console.log('Login successful...', response);
      }
      const returnUrl = getLoginReturnUrl();
      if (returnUrl) {
        window.sessionStorage.removeItem(LOGIN_RETURN_URL_KEY);
        window.location.assign(returnUrl);
      } else {
        window.location.assign('/');
      }
      window.location.assign('/');
    } else {
      // Magic link expired or invalid
      window.alert(t('auth.loginFailed'));
      window.location.assign('/signin');
    }
  } catch (err) {
    if (err.message === t('auth.noAuthState')) {
      window.alert(err.message);
      window.location.assign('/signin');
    } else if (err.isSuperTokensGeneralError === true) {
      // Custom error message from the API
      window.alert(err.message);
    } else {
      console.log('Error in magic link consuming attempt: ', err);
      window.alert(t('auth.genericError'));
    }
  }
}
